const env = (key) => {
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
};

const isDev = env('REACT_APP_NODE_ENV') === "development";
const isStage = env('REACT_APP_NODE_ENV') === "stage";
const isInternal = env('REACT_APP_NODE_ENV')=== "internal";

module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: isInternal? env('REACT_APP_API_URL') : isDev ? "http://localhost:3002": isStage? "https://api.stage.fadelisy.bnet-tech.com" : "https://api.falling.bnet-tech.com",
  },
  socket: {
    SOCKET_URL: isInternal? env('REACT_APP_SOCKET_URL') : isDev ? "ws://localhost:3002" : isStage? "wss://api.stage.fadelisy.bnet-tech.com" : "wss://api.falling.bnet-tech.com",
    SOCKET_PATH: isDev ? "/socket.io/" : isStage? "/socket.io/" : "/socket.io/",
  }
};

console.log('Environment: ' + env('REACT_APP_NODE_ENV'));
console.log('REACT_APP_SOCKET_URL: ' + env('REACT_APP_SOCKET_URL'));